import angular from 'angular'
import Navbar from './navbar/navbar'
import User from './user/user'
import Footer from './footer/footer'
import mcactionbutton from './mcactionbutton/mcactionbutton'
import loader from './loader/loader'
import color from './color/color'
import share from './share/share'

const commonModule = angular.module('app.common', [
    Navbar,
    User,
    Footer,
    mcactionbutton,
    loader,
    color,
    share
])

    .name

export default commonModule



// WEBPACK FOOTER //
// ./client/app/common/common.js